/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Nexus Imports
 */
import { NeuIcon } from '@neutron/react';

/**
 * Internal Imports
 */
import { Dropdown, IDropdownProps } from '../../shared/dropdowns';
import { formatRoundingType } from '../../../utils/helpers';

interface IRoundingTypeDropdownProps extends IDropdownProps {
  options: any[];
  selectedRoundingType: string;
  setSelectedRoundingType: (type: string) => void;
}

const RoundingTypeDropdown: FC<IRoundingTypeDropdownProps> = ({
  options = [],
  selectedRoundingType,
  setSelectedRoundingType,
  ...rest
}) => {
  return (
    <Dropdown classes="px-0" {...rest}>
      {[...options].map((type: string) => {
        const selected = selectedRoundingType === type;
        return (
          <div
            key={type}
            aria-selected={selected}
            className={`dropdown-hover-item ${selected ? 'selected' : ''}`}
            role="option"
            tabIndex={0}
            onClick={() => setSelectedRoundingType(type)}
            onKeyDown={() => setSelectedRoundingType(type)}
          >
            <div>
              {formatRoundingType(type)}
              {selected && (
                <NeuIcon className="custom-checkmark" color="blue">
                  check
                </NeuIcon>
              )}
            </div>
          </div>
        );
      })}
    </Dropdown>
  );
};

export default RoundingTypeDropdown;
